module.exports = __webpack_public_path__ + "static/media/awards_17.24cf444e.jpg";